import { IntegrationSystem } from '@biteinc/enums';

export function getLoyaltySsoUrl(
  loyaltySystem: IntegrationSystem.Loyalty,
  authUrl: string,
  redirectUrl: string,
): string {
  switch (loyaltySystem) {
    case IntegrationSystem.AtriumLoyalty:
      return `${authUrl}&partner=bite&url=${redirectUrl}`;
    // case IntegrationSystem.CbordLoyalty:
    //   return `${authUrl}&redirecturl=${redirectUrl}`;

    case IntegrationSystem.Appfront:
    case IntegrationSystem.CheetahOloLoyalty:
    case IntegrationSystem.ChoptLoyalty:
    case IntegrationSystem.Como:
    case IntegrationSystem.ComoOlo:
    case IntegrationSystem.GivexLoyalty:
    case IntegrationSystem.Incentivio:
    case IntegrationSystem.LovesRewards:
    case IntegrationSystem.LoyaltyPlant:
    case IntegrationSystem.Lunchbox:
    case IntegrationSystem.OloAccountsLoyalty:
    case IntegrationSystem.PaytronixLoyalty:
    case IntegrationSystem.PaytronixOlo:
    case IntegrationSystem.PeetsPaytronixOlo:
    case IntegrationSystem.PinataLoyalty:
    case IntegrationSystem.Punchh:
    case IntegrationSystem.PunchhOlo:
    case IntegrationSystem.SessionMOlo:
    case IntegrationSystem.SmoothCommerce:
    case IntegrationSystem.Sparkfly:
    case IntegrationSystem.Spendgo:
    case IntegrationSystem.SpendgoOlo:
    case IntegrationSystem.StarbucksFullLoyalty:
    case IntegrationSystem.StarbucksPayAndEarnLoyalty:
    case IntegrationSystem.Thanx:
    case IntegrationSystem.ThanxOlo:
      throw new Error(`${loyaltySystem} does not support SSO authentication`);
  }
}
